import MarketApi from '@api/marketing'
import noticeStore from '@components/LocalMerchant/NoticeChat/store'
import {
  isHotelProperty,
  isPureUltimate,
  isSiDaProperty
} from '@merchant-backend/util'
import { HLJ_STATISTIC, isSiDaTeam, isTelSaleCityMerchant } from '@util'
import { action, observable } from 'mobx'
import React from 'react'

class Store {
  @observable detail = {}
  @observable merchant_use_list = []
  @observable coupon = {}
  @observable pay_money = {}
  @observable personal_ultimate_num = 0 // 赠送个人旗舰版数量
  @observable video = {}
  @observable loading = true

  @observable type = '1' //1 旗舰版 2 标准版
  @observable showAffix = false

  @observable purchaseData = {}
  @observable showModal = false

  @action
  setStoreData = (type, value) => {
    this[type] = value
    if (type === 'type') {
      if (value === '1') {
        HLJ_STATISTIC({
          element_tag: 'pro_page'
        })
      } else {
        HLJ_STATISTIC({
          element_tag: 'standard_page'
        })
      }
    }
    this.setBottom()
  }

  @action
  getDetail = async () => {
    const { data, success } = await MarketApi.getBuyInfo()
    this.loading = false
    if (success) {
      this.detail = data.merchant || {}
      this.merchant_use_list = data.merchant_use_list || []
      this.coupon = data.coupon || {}
      this.pay_money = data.pay_money || {}
      this.personal_ultimate_num = data.personal_ultimate_num
      this.video = data.video || {}

      this.setBottom()
    }
  }

  setBottom = () => {
    const { flagship_price = {}, standard_price = {} } = this.pay_money
    if (this.type == '2' && !isPureUltimate() && standard_price.fee) {
      noticeStore.setBottom('120px')
    } else if (this.type == '1' && flagship_price.fee) {
      noticeStore.setBottom('120px')
    } else {
      noticeStore.setBottom()
    }
  }

  @action
  getPurchaseData = async () => {
    const { data } = await MarketApi.getShopProductPrice()
    this.purchaseData = data
  }

  getPageConfig = () => {
    const isHotel = isHotelProperty()
    const siDaTeam = isSiDaTeam()
    const isSiDa = isSiDaProperty()

    const getShopShowImg = () => {
      if (isHotel) {
        return '//qnm.hunliji.com/o_1dph9aeqbsv9vfr1spg1llscbe9.png'
      }

      if (isSiDa) {
        if (siDaTeam) {
          return 'https://qnm.hunliji.com/o_1dnubj7k6g9ji6i1rhg1bnnnmu9.png'
        }
        return '//qnm.hunliji.com/o_1dn9hta2i17cj1efc1vum1bl73vd9.png'
      }

      return '//qnm.hunliji.com/o_1d4s8qe7gphbnibl9hbrs521j.png'
    }

    const getBanner = () => {
      if (isHotel) {
        return '//qnm.hunliji.com/o_1dl1rrkkun8j11ch10qd14an7v19.png'
      }

      // 电销显示尊享版宣传图
      if (isTelSaleCityMerchant()) {
        return '//qnm.hunliji.com/o_1dpu8v4tm1pd6fc813gd1s9u4en9.png'
      }

      return '//qnm.hunliji.com/o_1d4s8ddbido7vctutccts13o3e.png'
    }

    return {
      BANNER: getBanner(),
      HEADER_ONE: isHotel ? '店铺展示' : siDaTeam ? '精美团队主页' : '店铺装修',
      HEADER_ONE_TIP: siDaTeam ? (
        <span>
          团队成员/作品/动态，丰富呈现<br />打造团队品牌流量矩阵
        </span>
      ) : (
        '个性化定制，吸引用户关注'
      ),
      SHOP_SHOW_IMG: getShopShowImg(),
      SHOP_SHOW_ICON: isHotel
        ? '//qnm.hunliji.com/o_1dpfcb9eg99jm6715t41b0g19mdt.png'
        : '//qnm.hunliji.com/o_1d4hpvflq8hg18jv4cbk741m47o.png',
      PROMISE_IMG: isHotel
        ? '//qnm.hunliji.com/o_1dpkd7b3k80t1koo1u251si64m3e.png'
        : '//qnm.hunliji.com/o_1d4ho0u197211m1j1etv17erpm5e.png',
      CONSULT_IMG: isHotel
        ? '//qnm.hunliji.com/o_1dpkd75il1g8nmj714ov1ujns719.png'
        : '//qnm.hunliji.com/o_1d4ho1r461gt811gj7mpkhe3ooj.png',
      SKY_EYE_IMG: isHotel
        ? '//qnm.hunliji.com/o_1dlght74emad1hn9182ss1l1ngjo.png'
        : '//qnm.hunliji.com/o_1d4hq0b0on7j2ea1hmr56lddft.png',
      COLLECT_ICON: isHotel
        ? '//qnm.hunliji.com/o_1dl229ah36vl1jvh1fuh1j7r1vlfp.png'
        : '//qnm.hunliji.com/o_1d4hq4d2hntr11loo9i14e49o212.png',
      SHARE_ICON: isHotel
        ? '//qnm.hunliji.com/o_1dl229ah31gdemvurc1dpjq9gq.png'
        : '//qnm.hunliji.com/o_1d4hq4nen14btt6dqisumi5ef17.png',
      SOURCE_TABLE_IMG: isSiDa
        ? '//qnm.hunliji.com/o_1dg076soudug1th01ibs8ufm8h9.png'
        : '//qnm.hunliji.com/o_1d4pbvhgg9jsr066uglr59fr9.png',
      MULTI_STORE_IMG: isHotel
        ? '//qnm.hunliji.com/o_1dlght74e6169ks1cf91nrcodl.png'
        : '//qnm.hunliji.com/o_1d4i3qti715cln1d1jevf3no5ro.png'
    }
  }
}

export default Store
